import * as THREE from 'three';
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger);

export default function firstview() {
  const container = document.getElementById('firstview');
  if (!container) {
    console.error('Element with id "firstview" not found');
    return;
  }

  // シーンの設定
  let rotationFlag = true
  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(70, container.clientWidth / container.clientHeight, 0.1, 1000);
  
  if(window.innerWidth > 1119){
    camera.position.z = 2.3;
  }else if(window.innerWidth > 640){
    camera.position.z = 3;
  }else{
    camera.position.z = 3.6;
  }

  const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
  renderer.setSize(container.clientWidth, container.clientHeight);
  container.appendChild(renderer.domElement);

  const textureLoader = new THREE.TextureLoader();

  // 地球の設定
  const earthTexture = textureLoader.load('./images/common/texture.webp');
  earthTexture.mapping = THREE.EquirectangularReflectionMapping;
  earthTexture.minFilter = THREE.LinearFilter;
  earthTexture.magFilter = THREE.LinearFilter;

  const earthGeometry = new THREE.SphereGeometry(1, 32, 32);
  const earthMaterial = new THREE.MeshBasicMaterial({ map: earthTexture });
  const earth = new THREE.Mesh(earthGeometry, earthMaterial);
  scene.add(earth);

  // 星空の設定
  const starsTexture = textureLoader.load('./images/common/firstview.webp');
  starsTexture.mapping = THREE.EquirectangularReflectionMapping;
  starsTexture.minFilter = THREE.NearestFilter;
  starsTexture.magFilter = THREE.NearestFilter;
  const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
  starsTexture.anisotropy = maxAnisotropy;

  const starsGeometry = new THREE.SphereGeometry(4, 64, 64);
  const starsMaterial = new THREE.MeshBasicMaterial({
    map: starsTexture,
    side: THREE.BackSide,
  });
  const stars = new THREE.Mesh(starsGeometry, starsMaterial);
  scene.add(stars);

  // 星のグループを作成
  const starGroup = new THREE.Group();
  scene.add(starGroup);

  // ランダムに星を配置する関数
  function createStars() {
    const starGeometry = new THREE.SphereGeometry(0.01, 1, 1);
    const starMaterial = new THREE.MeshBasicMaterial({ color: 0xfdeb02});

    for (let i = 0; i < 20; i++) {
      const star = new THREE.Mesh(starGeometry, starMaterial);

      // ランダムな位置に配置
      star.position.x = THREE.MathUtils.randFloatSpread(2);
      star.position.y = THREE.MathUtils.randFloatSpread(2);
      star.position.z = THREE.MathUtils.randFloatSpread(2);

      starGroup.add(star);
    }
  }

  createStars();

  earth.position.y = 0.066;
  starGroup.position.y = 0.066;


  function animate() {
    requestAnimationFrame(animate);
    if(rotationFlag){
      earth.rotation.y += 0.003;
    }
    starGroup.rotation.y += 0.02;
    stars.rotation.y += 0.001;
    renderer.render(scene, camera);
  }

  window.addEventListener('resize', () => {
    const width = container.clientWidth;
    const height = container.clientHeight;
    renderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  });

  // アニメーションの開始
  animate();


  gsap.fromTo(camera.scale,
    {},
    {
      z: 2.5,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=200%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )
  gsap.fromTo(earth.rotation,
    {},
    {
      y: 2.35,
      x: -.3,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=200%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
        onLeave: ()=>{
          rotationFlag = false
        },
        onEnterBack: ()=>{
          rotationFlag = true
        }
      }
    }
  )
  gsap.fromTo(earth.position,
    {},
    {
      y: -1,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=200%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

  // UFO
  gsap.fromTo('#firstview .firstview__ufo',
    {},
    {
      top: '60%',
      left: '50%',
      scale: 0,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=160%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

  // フロー部分
  gsap.fromTo(camera.scale,
    {},
    {
      z: 1,
      scrollTrigger: {
        trigger: '#recruit',
        start: "top top-=25%",
        end: "top top-=200%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
        onEnter: ()=>{
          rotationFlag = true
        },
        onLeaveBack: ()=>{
          rotationFlag = false
        }
      }
    }
  )

  gsap.fromTo(earth.position,
    {},
    {
      y: 0.066,
      scrollTrigger: {
        trigger: '#recruit',
        start: "top top-=25%",
        end: "top top-=200%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )
}
